import React, { useState } from "react";
import { connect } from "react-redux";
import { useDebouncedCallback } from "use-debounce";
import styles from "./EditorBox.module.css";
import { updateSlides } from "../../../store/actions/updateSlideList";
import {
	updateAutoSave,
	updateLastSaved,
} from "../../../store/actions/updateAutoSave";
import { UndoRedo } from "../../../helpers/undoRedo";
import { updateSlide as api_updateSlide } from "../../../helpers/api";
import { getLayout } from "./helpers/getLayout";
import { getViewLayout } from "./helpers/getViewLayout";
import { updatePreview } from "./helpers/updatePreview";
import SlideList from "../SlideList/SlideList";
import Layout from "../Layout.json";
import SnackBar from "../../reusable/SnackBar/SnackBar";

const EditorBox = (props) => {
	const [error, setError] = useState(false);

	const debounced = useDebouncedCallback(async (props, slide) => {
		props.updateAutoSave({ saving: true });
		let hasTextArea = false;
		switch (slide.layout) {
			case Layout.normal:
			case Layout.double:
			case Layout.doubleSubtitle:
			case Layout.pictureLeft:
			case Layout.pictureRight:
				hasTextArea = true;
				break;

			default:
				hasTextArea = false;
				break;
		}
		let preview = await updatePreview(props, slide.id, hasTextArea);
		if (preview) slide.preview = preview;
		try {
			let keys = Object.keys(slide.data);
			for (let i = 0; i < keys.length; i++) {
				if (typeof slide.data[keys[i]] === "string") {
					slide.data[keys[i]] = slide.data[keys[i]].trim();
				}
			}
			await api_updateSlide(props.slidesMetaData.id, slide);
			UndoRedo.updateSlide(slide);
		} catch (err) {
			setError({
				message: err || "Unknown Error!",
				severity: "error",
			});
		}
		props.updateAutoSave({ saving: false });
		props.updateLastSaved({
			lastSaved: Date.now(),
		});
	}, 1000);

	const closeSnackBar = () => {
		setError(false);
	};

	const showLayout = () => {
		let slide = props.slideList.slides[props.slideList.activeSlide];
		if (slide) {
			return getLayout(
				props,
				slide.id,
				slide.layout,
				slide.data,
				debounced
			);
		}
		return null;
	};

	const viewLayout = () => {
		let slide = props.slideList.slides[props.slideList.activeSlide];
		if (slide) {
			return getViewLayout(slide.id, slide.layout, slide.data);
		}
		return null;
	};

	return (
		<div className={styles.editorBox}>
			<div className={styles.slideList}>
				<SlideList />
			</div>
			{props.editorState.editor && (
				<div className={styles.layout}>{showLayout()}</div>
			)}
			{props.editorState.design && props.designMode.background && (
				<div className={styles.layout}>{viewLayout()}</div>
			)}
			<SnackBar
				open={error}
				handleClose={closeSnackBar}
				message={error.message}
				severity={error.severity}
			/>
		</div>
	);
};

const mapStateToProps = (state) => ({
	...state,
});
const mapDispatchToProps = (dispatch) => ({
	updateSlides: (payload) => dispatch(updateSlides(payload)),
	updateAutoSave: (payload) => dispatch(updateAutoSave(payload)),
	updateLastSaved: (payload) => dispatch(updateLastSaved(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditorBox);
